const DATE_OPTIONS: Intl.DateTimeFormatOptions = {
	dateStyle: "short",
	timeStyle: "short",
};

const OLD_DATES: any = {
	259200: "orange",
	1209600: "deepOrange",
};

export function getPeriodColor(date: number) {
	var now: number = Math.floor(Date.now() / 1000);
	var result: string = "";
	for (let d of Object.keys(OLD_DATES)) {
		if (date < now - parseInt(d)) {
			result = OLD_DATES[d];
		}
		return result;
	}
}

export default function dateToHuman(date: number | string) {
	if (typeof date == "number") date *= 1000;
	const realDate = new Date(date);
	return Intl.DateTimeFormat("ru-RU", DATE_OPTIONS).format(realDate);
}
